const sizesScaleRatio = 0.1;
const zSize = 1800 * sizesScaleRatio;

export const PREVIEW_GEOMETRY_SCALE = 1;

export const REF_SIZE = {
    w: 1920,
    h: 1080,
    previewScale: PREVIEW_GEOMETRY_SCALE,
    ratio: {
        x: sizesScaleRatio,
        y: sizesScaleRatio
    }
};

export const REF_SIZE_PT = {
    w: 750,
    h: 1300,
    previewScale: PREVIEW_GEOMETRY_SCALE * 1.5,
    ratio: {
        x: sizesScaleRatio * 2,
        y: sizesScaleRatio * 2.4
    }
};

export const UNIT = {
    sizesScaleRatio,
    zSize,
    camDistance: zSize * 0.9,
    camFar: 4200 * sizesScaleRatio,
    xSize: 300 * sizesScaleRatio
};

export const SIZE_OPTIONS = {
    LANDSCAPE: 'landscape',
    PORTRAIT: 'portrait'
};

export const SIZE_REFS_MAP = {
    landscape: REF_SIZE,
    portrait: REF_SIZE_PT
};
